import React from 'react';
import { Small } from '@finect/tabular-core/Small';
import { AssetsLabel } from '../../../Labels';
export var Price = function Price(_ref) {
  var value = _ref.value,
    decimals = _ref.decimals;
  return React.createElement("span", null, value > 0 ? React.createElement("span", null, React.createElement(AssetsLabel, {
    value: value,
    decimals: decimals
  }), '  ', React.createElement(Small, {
    light: true
  }, "IVA incluido.")) : React.createElement("span", null, "Gratuito"));
};